import styled from 'styled-components';

import {
  Card,
  CardBody,
  CardHeader,
  CardIcon,
} from '../../../../components';
import THEME from '../../../../constants/theme';

export const CardWrapper = styled(Card)`
  max-width: ${({ $bigSize }) => ($bigSize ? '1008px' : '872px')};
  margin-bottom: 64px !important;
`;

export const CardHeaderWrapper = styled(CardHeader)`
  display: flex;
  flex-direction: row;
`;

export const CardBodyWrapper = styled(CardBody)`
  @media(min-width: 768px) {
    margin-left: 50px;
    margin-right: 50px;
  }

  & .CustomInput-formControl-180 {
    margin: 0;
  }
`;

export const HeaderIcon = styled(CardIcon)`
  background: ${THEME.primary};
  color: ${THEME.white};
  box-shadow: 0px 4px 8px rgba(95, 175, 193, 0.4);
  border-radius: 8px;
  height: 56px;
  width: 56px;
  padding: 16px;
  margin-top: -32px;
  margin-right: 16px;
`;

export const HeaderText = styled.span`
  height: 24px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: ${THEME.bobBlack};
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 70px;
`;
